import { render, staticRenderFns } from "./DeliveryBill.vue?vue&type=template&id=37b40559&scoped=true&"
import script from "./DeliveryBill.vue?vue&type=script&lang=js&"
export * from "./DeliveryBill.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryBill.vue?vue&type=style&index=0&id=37b40559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b40559",
  null
  
)

export default component.exports